export default __webpack_public_path__ + "static/media/Path509.e272389a.png";